var React = require('react');

function ShapeDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1920 0L1677.86 199.837C1640.73 230.48 1592.29 243.834 1544.71 236.546L0 0V243H1920V0Z","fill":"currentColor"}));
}

ShapeDown.defaultProps = {"width":"1920","height":"243","viewBox":"0 0 1920 243","fill":"none","preserveAspectRatio":"none"};

module.exports = ShapeDown;

ShapeDown.default = ShapeDown;
